export const GalaxySVG = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#8A2BE2">
    <circle cx="50" cy="50" r="45" fill="none" stroke="#8A2BE2" strokeWidth="4"/>
    <circle cx="50" cy="50" r="30" fill="none" stroke="#8A2BE2" strokeWidth="2"/>
    <circle cx="50" cy="50" r="15" fill="none" stroke="#8A2BE2" strokeWidth="1"/>
    <circle cx="25" cy="25" r="3" fill="#8A2BE2"/>
    <circle cx="75" cy="25" r="3" fill="#8A2BE2"/>
    <circle cx="25" cy="75" r="3" fill="#8A2BE2"/>
    <circle cx="75" cy="75" r="3" fill="#8A2BE2"/>
    <circle cx="50" cy="10" r="3" fill="#8A2BE2"/>
    <circle cx="50" cy="90" r="3" fill="#8A2BE2"/>
    <circle cx="10" cy="50" r="3" fill="#8A2BE2"/>
    <circle cx="90" cy="50" r="3" fill="#8A2BE2"/>
  </svg>
);